<template>
    <div class="row">
        <Loading v-if="showLoading" />
        <div class="col-md-3">
            <div class="card custom-card card-body bg-warning tx-white">
                <h6>فیلتر دسته بندی ها</h6>
                <hr class="mb-4 mt-2">
                <label class="ckbox"><input type="checkbox" value="all" id="select-all" checked @change="selectAll"><span>انتخاب همه</span></label>
                <label class="ckbox mt-3" v-for="(category,index) in categories" :key="index"><input type="checkbox" checked @change="changeCategories(category.categoryId)" :value="category.categoryId" :id="'category-' + category.categoryId"><span>{{ category.title }}</span></label>
            </div>
        </div>
        <div class="col-md-9">
            <div class="row" v-if="!themeId && allCards.length">
                <div class="col-md-3 card-container" v-for="(card,index) in cards" :key="index">
                    <img :src="'https://cardapi.sabinarya.com' + card.address" :alt="card.title">
                    <h5>{{ card.title }}</h5>
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <div class="form-group">
                                <input type="number" class="form-control ltr-input" v-model="card.count" v-on:keyup="card.count = parseInt(card.count)" placeholder="تعداد" min="0">
                            </div>
                        </div>
                        <div class="col-md-3 pr-0">
                            <button @click="add(card)" class="btn ripple btn-success btn-icon btn-block"><i class="fe fe-check"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else-if="!allCards.length">
                <div class="col-md-3 card-container" v-for="index in 8" :key="index">
                    <span class="image-placeholder animate"></span>
                    <h5 class="title-placeholder animate"></h5>
                    <div class="row justify-content-center">
                        <div class="col-md-4"><button class="btn ripple btn-placeholder btn-icon animate btn-add-to-card"></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FizicalCard',
    props: ['addToCard','depositsList','customerId'],
    data(){
        return {
            allCards: [],
            cards: [],
            categories: [],
            selectedCategories: [],
            cartCards: [],
            cardType: 1,
            themeId: '',
            file: '',
            discount: 0,
            resultFile: '',
            showLoading: false
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/AvailableThemes').then(({data}) => {
                setTimeout(() => {
                    this.allCards = data.result;
                    this.cards = data.result;
                },1000);
            });
            this.$api.get('Cards/Categories').then(({data}) => {
                this.categories = data.result;
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                });
            });
        },
        add(card){
            this.showLoading = true;
            const postedData = {
                domainDataId: this.customerId,
                byCount: true,
                count: card.count,
                themeId: card.themeId,
                discount: 0
            };
            this.$api.post('Organizations/Bonus/Order',postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.fileString : '';
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت درخواست بن کارت با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'foreignBonusCards.index'});
                        }
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setFilterType(element,type){
            let filterTypes = document.getElementsByClassName('filter-item');
            for(let i = 0;i < filterTypes.length;i++){
                if(typeof filterTypes[i] == 'object')
                    filterTypes[i].classList.remove('active');
            }
            element.target.classList.add('active');
        },
        changeCategories(id){
            this.cards = [];
            if(this.selectedCategories.includes(id))
                this.selectedCategories.splice(this.selectedCategories.indexOf(id),1);
            else
                this.selectedCategories.push(id);
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        },
        selectAll(e){
            this.selectedCategories = [];
            this.cards = [];
            if(e.target.checked)
                this.categories.map(category => {
                    this.selectedCategories.push(category.categoryId);
                    document.getElementById('category-' + category.categoryId).checked = true;
                });
            else
                this.categories.map(category => {
                    document.getElementById('category-' + category.categoryId).checked = false;
                });
            this.selectedCategories.map(categoryId => {
                this.allCards.map(card => {
                    if(card.categories.includes(categoryId))
                        this.cards.push(card);
                });
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>